var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVacateHouseCerti2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 70,
    viewBox: "0 0 100 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 6H44.9726L41.699 13.6025L50 28.6957L48.7139 47.9255L54.3259 28.6957L47.7786 12.7081L51.403 6H73.5V60H26.5V6Z",
    fill: "#CFD9E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7673 22C31.7673 21.4477 32.215 21 32.7673 21H45.5L46.5 23H32.7673C32.215 23 31.7673 22.5523 31.7673 22Z",
    fill: "#BBC5D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7673 21.9991C68.7673 22.5516 68.3189 22.9992 67.7664 22.9981L52 22.9688L51.5 21L67.7683 21C68.32 21 68.7673 21.4473 68.7673 21.9991Z",
    fill: "#BBC5D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7673 31C31.7673 30.4477 32.215 30 32.7673 30H49.7673V32H32.7673C32.215 32 31.7673 31.5523 31.7673 31Z",
    fill: "#BBC5D1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5347 30.999C68.5347 31.5515 68.0862 31.9991 67.5336 31.9979L53.5 31.9688L54.2327 30L67.5357 30C68.0874 30 68.5347 30.4473 68.5347 30.999Z",
    fill: "#BBC5D1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7673 40C31.7673 39.4477 32.215 39 32.7673 39H49V41H32.7673C32.215 41 31.7673 40.5523 31.7673 40Z",
    fill: "#BBC5D1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7673 39.9991C68.7673 40.5516 68.3189 40.9992 67.7665 40.9982L51 40.9688L51.5 39L67.7682 39C68.32 39 68.7673 39.4473 68.7673 39.9991Z",
    fill: "#BBC5D1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7673 49C31.7673 48.4477 32.215 48 32.7673 48H67.7673C68.3196 48 68.7673 48.4477 68.7673 49C68.7673 49.5523 68.3196 50 67.7673 50H32.7673C32.215 50 31.7673 49.5523 31.7673 49Z",
    fill: "#BBC5D1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacateHouseCerti2);
export default __webpack_public_path__ + "static/media/VacateHouseCerti2.814e0709d3ddff37c57cc663d0b3e789.svg";
export { ForwardRef as ReactComponent };